<template>
  <Modal title="Course Report" v-model="showModal" width="750">
    <div class="evaluate">
      <h3>Part one： Class Performance(minimum 2 stars, maximum 5 stars)  :</h3>
      <Form  ref="formData"
         class="feedback form regluarForm" label-position="top" v-model="formData">
        <Row>
          <Col :span="20" >
            <Form-item label="Focus：">
              <el-rate v-model="formData.rate1"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Speaking Frequency：">
              <el-rate v-model="formData.rate2" @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Listening Comprehension Accuracy：">
              <el-rate v-model="formData.rate3"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Fluency and Cohisence：">
              <el-rate v-model="formData.rate4"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Connection and Device：">
              <el-rate v-model="formData.rate5"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20" >
            <Form-item label="Classroom Environment：">
              <el-rate v-model="formData.rate6"  @change="handleChange"></el-rate>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
  
      <div class="evaluate">
        <h3>Part two: Teacher's Feedback(at least 30 words)  :</h3>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="Enter something..."
          v-model="formData.parent">
        </el-input>
        <span>{{remark}}</span>
      </div>
    <div slot="footer">
      <Button type="text" size="large" @click="onClose">Cancel</Button>
      <Button v-if="!readonly" type="primary" size="large" :loading="loading" @click="onSubmit">Submit</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'StudentWriteReviewRegularV2',
    props: {
      formData: {
        type: Object,
        default: {
          return: {
            rate1: 2,
            rate2: 2,
            rate3: 2,
            rate4: 2,
            rate5: 2,
            rate6: 2,
            parent: '',
          }
        }
      },
      value: {
        type: Boolean,
        default: {
          return: false
        }
      },
      openedId: {
        type: Number
      },
      reviewState: {
        type: Number
      },
      successCallback: {
        type: Function
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        uid: '',
        openid: '',
        state: '',
        form: {
          rating: 4
        },
        rateValue: 0,
        v1: 4,
        v2: 2,
        showModal: this.value,
        loading: false,
        lessonErrRule: {
          remark: [
            { type: 'string', required: true, message: ' ', trigger: 'blur' }
          ],
        },
        remark: 'Please review the lesson content from our app today, I hope to see you again in the next class.'
      }
    },
    methods: {
      changeFile (fileList) {
        this.formData.fileList = fileList
      },
      deleteItem (element, index, limit) {
        if (element.length === 1) {
          this.$Message.warning(`can't not remove defalut input`)
          return
        }
        if (element.length > limit) {
          element.splice(index, 1)
        } else {
          this.$Message.warning(`At least ${limit} words!`)
        }
      },
      addItem (element) {
        element.push({ remark: '' })
      },
      handleChange (value) {
        this.formData.rate1 = this.formData.rate1 > 2 ? this.formData.rate1 : 2
        this.formData.rate2 = this.formData.rate2 > 2 ? this.formData.rate2 : 2
        this.formData.rate3 = this.formData.rate3 > 2 ? this.formData.rate3 : 2
        this.formData.rate4 = this.formData.rate4 > 2 ? this.formData.rate4 : 2
        this.formData.rate5 = this.formData.rate5 > 2 ? this.formData.rate5 : 2
        this.formData.rate6 = this.formData.rate6 > 2 ? this.formData.rate6 : 2
      },
      starChange (v) {
        console.log(this.v2)
        console.log(this.v2)
      },
      onClose () {
        this.$emit('on-close')
      },
      getWord (element) {
        if (!element) {
          return []
        }
        let word = []
        element.match(/[^,，\s]+/g).forEach(v => {
          if (v.trim() !== '') {
            word.push(v.trim()) // 去除单词前后的空格
          }
        })
        return word
      },
      hasNumWords (str, num) {
        const words = str.split(' ') // 将字符串按空格切割成单词数组
        return words.length >= num // 判断单词数量是否大于等于80
      },
      onload () {
        let self = this
        self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(res => {
          let {uid, learnedComment} = res.data
          self.uid = uid
          if (learnedComment) {
            let {part1, part3} = JSON.parse(learnedComment)
            let rateList = part1.split(',')
            let intList = rateList.map(v => parseInt(v, 10))
            if (rateList.length >= 6) {
              [this.formData.rate1, this.formData.rate2, this.formData.rate3, this.formData.rate4, this.formData.rate5, this.formData.rate6] = intList
            }
            this.handleChange() // 判断一下 rate的值
           
            this.formData.parent = part3[0]
          } else {
            [this.formData.rate1, this.formData.rate2, this.formData.rate3, this.formData.rate4, this.formData.rate5, this.formData.rate6] = [2, 2, 2, 2, 2, 2]
          }
        })
      },
      onSubmit () {
        let self = this
        let word1 = this.getWord(this.formData.parent)
        if (word1.length < 30) {
          this.$Message.error("Teacher's Feedback of the words: At least 30 words!")
          return
        }
      
        let part1 = []
        part1.push(this.formData.rate1 + '')
        part1.push(this.formData.rate2 + '')
        part1.push(this.formData.rate3 + '')
        part1.push(this.formData.rate4 + '')
        part1.push(this.formData.rate5 + '')
        part1.push(this.formData.rate6 + '')
        
        let part3 = {
          0: this.formData.parent
        }
        let data = {
          part1: part1.join(','),
          part3: part3
        }
        let parmas = {}
        parmas.learnedComment = JSON.stringify(data)
        parmas.lsnOpenId = self.openid
        parmas.reviewState = self.state
        parmas.uid = self.uid
        parmas.version = 2
        this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
          if (res && res.status === 'ok') {
            self.$Message.success('success!')
            self.showModal = false
            self.$emit('on-close')
            self.successCallback(res.data)
          }
        }).catch(function (e) {
          // this.loadingUpdate = false
        })
      },
    },
    watch: {
      reviewState (val) {
        this.state = val
      },
      openedId (val) {
        this.openid = val
      },
      myValue (val) {
        console.log(this.v2)
        this.myValue = 2
        this.v1 = 3
        this.$nextTick()
      },
      value (val) {
        this.showModal = val
        if (val === true) {
          console.log(1231321)
            // this.scoreCompute()
          this.onload()
        } else {
          // this.feedback = {}
          // this.visible = val
        }
      },
      showModal (val) {
        if (val === false) {
          this.$emit('on-close')
        }
      },
      formData (val) {
        if (val) {
          this.lessonErrFormData = val
        }
      }
    }
  }
</script>
<style>
.title {
padding: 10px 0px 10px 0px ;
font-size: 16px;
}
.msg::after {
content: 'bug';
}
.square {
margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// StudentWriteReviewRegularV2Modal.vue?3aff570c